import useApi from '../../../services/useApi'
import useFilters from '../../../hook/useFilters'
import moment from 'moment'
import {useState} from 'react'

export const useGetCustomerTypeReport = () => {
  const Api = useApi()
  const [dateRange] = useState(() => JSON.parse(localStorage.getItem('selectedDateRange') || '{}'))

  const initialFilters = {
    sort_by: 'total_discount/-1',
    start_date: dateRange?.startDate ?? moment().subtract(3, 'months').format('YYYY-MM-DD'),
    end_date: dateRange?.endDate ?? moment().format('YYYY-MM-DD'), // includes today
  }
  const {filters, onSortingChange, onDateChange} = useFilters(initialFilters, {sortType: 'number'})
  const {data: response, isFetching} = Api.useGetQuery(
    '/analytics/coupon-discount/report/customer-types',
    {
      queryId: 'coupon-code-customer-type-report',
      filters,
      isToast: false,
      isErrorPageRedirection: false,
    }
  )
  return {
    reportData: response?.data || [],
    isLoading: isFetching,
    filters,
    onSortingChange,
    handleCustomerTypeReportDateChange: onDateChange,
  }
}
